import React, { memo, useCallback, useState } from 'react';
import Flag from 'react-world-flags';

import { IconButton } from '@mui/material';
import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { getWrapperStyles } from './Flags.styles';

const Flags = ({ code, width = 14, height, disabled = false, customStyles, dataTestId }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const onClick = useCallback(() => setIsExpanded(prev => !prev), []);

  return (
    <IconButton
      disableFocusRipple
      disableRipple
      data-testid={dataTestId}
      disabled={disabled}
      sx={getWrapperStyles({ disabled, customStyles })}
      onClick={onClick}
    >
      <Flag code={code} height={height} width={width} />

      <ArrowCheckIcon className="shrink-0" direction={isExpanded ? 'up' : 'down'} size={18} />
    </IconButton>
  );
};

Flags.propTypes = {
  code: PropTypes.string.isRequired,
  customStyles: PropTypes.object,
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default memo(Flags);
